import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { selectCurrentUser } from "../../store/userSlice/userSelectors";
import { selectLastCertificatesByCompanyName } from "../../store/certificateSlice/certificateSelectors";
import { PAGE_LIST } from "../index";
import Layout from "../Layout";
import GeneralHeader from "../../components/GeneralHeader";
import Footer from "../../components/Footer";
import { getAllCertificates } from "../../store/certificateSlice/certificateRequest";
import MemberAreaContainer from "../../containers/MemberAreaContainer";
import AutoDownloader from "../../components/AutoDownloader";
import { createTestReportLink, getQueryObject } from "../../helpers/urlBuilder";


const MemberAreaPage = () => {
  const dispatch = useDispatch();
  const { companyName } = useParams();
  const navigate = useNavigate();
  const currentUser = useSelector(selectCurrentUser);
  const companyList = useSelector(selectLastCertificatesByCompanyName) || [];
  const company = companyList.find((company) => company.name === companyName);
  const memberAreaAvailable = currentUser?.isAdmin || currentUser?.company?.name === company?.name;
  const query = getQueryObject();
  //auto download feature for reports
  const { testReportId } = query;
  const fileUrl = createTestReportLink(testReportId);

  useEffect(() => {
    dispatch(getAllCertificates());
  }, [])

  useEffect(() => {
    if (!currentUser || !company) {
      return;
    }

    if (!memberAreaAvailable) {
      navigate(PAGE_LIST.CERTIFICATE)
    }
  }, [currentUser, company]);

  return (
    <>
      <Layout
        header={<GeneralHeader />}
        center={!!currentUser ? <MemberAreaContainer company={company} /> : null}
        footer={<Footer />}
      />
      {
        testReportId ? <AutoDownloader fileUrl={fileUrl} hideText /> : null
      }
    </>

  );
}

export default MemberAreaPage;